import React from "react";
import logo from "../assets/img/mse-logo.webp";
import { Link } from "react-router-dom";

const TopBar = () => {
  return (
    <div className="topbar-border ">

        <div className="container ">
          <Link to="/dashboard" className="btn btn-base float-end mt-4 ">Dashboard <i className="bi bi-house-door-fill"></i> </Link>
          <div className="nav-logo  py-2 ">
              <img src={logo} alt="UCAT Logo"></img>
          </div>
        </div>

        
    </div>
  );
};

export default TopBar;
